// eslint-disable-next-line import/no-unresolved
import { GraphQLClient } from 'graphql-request';

import { getSdk, Sdk } from '../generated/payment-public-graphql';
import getEnv from '../utils/getEnv';

export class PaymentPublicClient {
  sdk: Sdk;

  constructor(versionNumber?: string) {
    const graphQLClient = new GraphQLClient(
      PaymentPublicClient.getPaymentURL(versionNumber)
    );
    this.sdk = getSdk(graphQLClient);
  }

  /**
   * Returns a SDK of rating-quoting backend.
   * @returns a sdk that has all APIs of rating-quoting backend.
   */
  public getSDK(): Sdk {
    return this.sdk;
  }

  /**
   * Retrieves the email address for a Quote id (legacy links) or an
   * ApplicationGroup id (current links). The backend accepts either.
   *
   * @param {string} quoteOrGroupId Quote id or ApplicationGroup id.
   * @returns {string} Returns a Promise for a string of email address
   */
  public async getEmailAddress(quoteOrGroupId: string): Promise<string> {
    const result = await this.sdk.getEmailAddress({
      quoteOrGroupId
    });
    return result.getEmailAddress;
  }

  /**
   * Resolve an inbound id (legacy Quote id or an ApplicationGroup id) to the
   * owning ApplicationGroup id, used to canonicalize /terms links.
   *
   * @param {string} id Quote id or ApplicationGroup id.
   * @returns {string} Returns a Promise for the ApplicationGroup id.
   */
  public async getApplicationGroupId(id: string): Promise<string> {
    const result = await this.sdk.getApplicationGroupId({ id });
    return result.getApplicationGroupId;
  }

  static versionUrl(baseUrl: string, versionNumber?: string): string {
    // regex to replace version number in url
    const regex = /\d{4}-\d{2}-\d{2}/g;
    return versionNumber ? baseUrl.replace(regex, versionNumber) : baseUrl;
  }

  public static getPaymentURL(versionNumber?: string): string {
    const { REACT_APP_PAYMENT_PUBLIC_GRAPHQL_URL } = getEnv();

    return PaymentPublicClient.versionUrl(
      REACT_APP_PAYMENT_PUBLIC_GRAPHQL_URL,
      versionNumber
    );
  }
}
